import * as React from "react";
import { UIComponentViewImpl } from '../uicomponentview';
import { UIDataModel } from '../uicomponent';
import { FileUploadProps, FileUploadState, FileUploadHandler, FileUploadStatus } from './fileuploadcomponent';
import { FileUploadCSSStyleImpl } from './fileuploadcss';

export class FileUploadView extends UIComponentViewImpl<UIDataModel>
{
    private fileUploadElement: HTMLInputElement;

    bindHandlers()
    {
       this.onSelectFile = this.onSelectFile.bind(this);
       this.onUploadButtonClick = this.onUploadButtonClick.bind(this);
    }
    
    draw(uiProps: FileUploadProps, uiState: FileUploadState, cssStyle: FileUploadCSSStyleImpl): JSX.Element {
       super.draw(uiProps, uiState, cssStyle); 

       return(
           <div style={cssStyle.getWrapperCSSStyle()}>
             <div style={{position: "relative", width: "100%"}}>
                 <div style={{position: "relative", float: "left", width: "100%"}}>
                    <input style={cssStyle.getInputCSSStyle()} ref={(item:any)=>this.fileUploadElement = item} onChange={this.onSelectFile} accept={uiProps.extentionsAccepted} multiple={uiProps.isMultipleFilesAllowed} type="file"/>
                    <div style={cssStyle.getButtonWrapperCSSStyle()}>
                        <button style={cssStyle.getButtonStyle(uiState.fileUploadStatus)}>
                            <img src={this.getImage(uiState.fileUploadStatus)} style={cssStyle.getUploadIconCSSStyle()}/>
                            <label style={cssStyle.getButtonText()}>
                            {uiState.buttonTitle}</label><br/>
                        </button> 
                    </div>
                 </div>
                 {/* <div style={cssStyle.getFileNameCSSStyle()}>
                     {uiState.fileName}
                  </div> */}
            </div>
            {/* {uiState.errorMsg !== "" && 
                <div style={cssStyle.getErrorMsgCSSStyle()}>
                {
                    uiState.errorMsg
                }
                </div>} */}
       </div>);
    } 

    getUIProps(): FileUploadProps
    {
       return super.getUIProps() as FileUploadProps;
    }

    validate(): boolean
    {
        if(this.fileUploadElement.files !== null && this.fileUploadElement.files.length > 0)
        {
           return true;
        }
        else
        {
            return false;
        }
    }

    getData(): any
    {
        if(this.fileUploadElement.files !== null)
        {
            if((this.getUIProps() as FileUploadProps).isMultipleFilesAllowed)
            {
                return this.fileUploadElement.files;
            }
            else
            {
                return this.fileUploadElement.files[0];
            }
        }
    }

    clearData()
    {
        this.fileUploadElement.value = '';
    }

    onUploadButtonClick()
    {
        this.fileUploadElement.click();    
    }

    private onSelectFile()
    {
        this.fileUploadElement.files !== null && 
                this.fileUploadElement.files.length > 0 && 
          (this.getUIComponentHandler() as FileUploadHandler).onSelectFile(this.fileUploadElement.files[0].name);
    }

    private getImage(fileStatus: FileUploadStatus)
    {
        if(fileStatus === FileUploadStatus.FILE_UPLOADING)
        {
            return this.getUIProps().context.getResources().getImage("uploading.svg");    
        }
        else if(fileStatus === FileUploadStatus.FILE_UPLOADED)
        {
            return this.getUIProps().context.getResources().getImage("uploaded.svg");     
        }
        else if(fileStatus === FileUploadStatus.FILE_UPLOAD_FAILED)
        {
            return this.getUIProps().context.getResources().getImage("upload_failed.svg");        
        }
        else
        {
            return this.getUIProps().context.getResources().getImage("upload.svg");    
        }
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/fileupload/fileuploadview.tsx